export const REGISTER_API ='register/'
export const LOGIN_API ='login/'
export const FORGOT_PASSWORD_API ='forgotPassword/'
export const RESET_PASSWORD_API ='resetPassword/'

// export const EMPLOYEE_INVITES_API ='employeeinvite/'